/**
 * Rental item page: photo gallery and detail tabs. The page works without this file.
 * Gallery: thumbnails swap the main photo. Hovering the main photo with a mouse magnifies it under the pointer.
 * Clicking or tapping it opens a full-screen viewer with previous and next, arrow keys, swipe, Esc and pinch zoom.
 */

function initGallery(root) {
  const main = root.querySelector('.rental-gallery__image');
  const frame = root.querySelector('[data-gallery-main]');
  const zoomBtn = root.querySelector('[data-gallery-zoom]');
  const thumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
  if (!main) return;

  const photos = thumbs.length
    ? thumbs.map((t) => ({ src: t.dataset.src, alt: t.dataset.alt || '' }))
    : [{ src: zoomBtn ? zoomBtn.dataset.src : main.currentSrc || main.src, alt: main.alt }];
  let current = 0;

  function show(index) {
    current = index;
    const thumb = thumbs[index];
    if (!thumb) return;
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.src = thumb.dataset.src;
    main.alt = thumb.dataset.alt || '';
    thumbs.forEach((other) => other.setAttribute('aria-current', String(other === thumb)));
  }
  thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));

  /* Hover magnifier: mouse and trackpad only, wide screens only */
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  if (frame) {
    frame.addEventListener('mousemove', (e) => {
      if (!canHover.matches) return;
      const box = frame.getBoundingClientRect();
      const x = ((e.clientX - box.left) / box.width) * 100;
      const y = ((e.clientY - box.top) / box.height) * 100;
      main.style.transformOrigin = x + '% ' + y + '%';
      frame.classList.add('is-magnified');
    });
    frame.addEventListener('mouseleave', () => frame.classList.remove('is-magnified'));
    frame.addEventListener('click', (e) => {
      if (e.target.closest('[data-gallery-zoom]')) return;
      openViewer(current);
    });
  }
  if (zoomBtn) zoomBtn.addEventListener('click', () => openViewer(current));

  /* Full-screen viewer, built on first use */
  let dialog = null;
  let img = null;
  let count = null;
  let opener = null;

  function build() {
    dialog = document.createElement('dialog');
    dialog.className = 'rental-zoom';
    dialog.setAttribute('aria-label', root.dataset.labelDialog || '');
    const multi = photos.length > 1;
    dialog.innerHTML =
      '<button type="button" class="rental-zoom__close" data-zoom-close></button>' +
      (multi ? '<button type="button" class="rental-zoom__nav rental-zoom__nav--prev" data-zoom-prev></button>' : '') +
      '<div class="rental-zoom__stage"><img class="rental-zoom__img" alt=""></div>' +
      (multi ? '<button type="button" class="rental-zoom__nav rental-zoom__nav--next" data-zoom-next></button>' : '') +
      (multi ? '<p class="rental-zoom__count" aria-live="polite"></p>' : '');
    const close = dialog.querySelector('[data-zoom-close]');
    close.setAttribute('aria-label', root.dataset.labelClose || 'Close');
    close.innerHTML = '<svg aria-hidden="true" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 5l14 14M19 5L5 19"/></svg>';
    img = dialog.querySelector('img');
    count = dialog.querySelector('.rental-zoom__count');
    if (multi) {
      const prev = dialog.querySelector('[data-zoom-prev]');
      const next = dialog.querySelector('[data-zoom-next]');
      prev.setAttribute('aria-label', root.dataset.labelPrev || 'Previous photo');
      next.setAttribute('aria-label', root.dataset.labelNext || 'Next photo');
      prev.innerHTML = '<svg aria-hidden="true" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 5l-7 7 7 7"/></svg>';
      next.innerHTML = '<svg aria-hidden="true" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 5l7 7-7 7"/></svg>';
      prev.addEventListener('click', () => step(-1));
      next.addEventListener('click', () => step(1));
    }
    close.addEventListener('click', () => dialog.close());
    /* A click on the dark backdrop closes; a click on the photo does not */
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog || e.target.classList.contains('rental-zoom__stage')) dialog.close();
    });
    dialog.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') step(-1);
      if (e.key === 'ArrowRight') step(1);
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('has-zoom');
      show(current);
      if (opener) opener.focus();
    });

    /* Swipe left or right with one finger; two fingers are left to the browser for pinch zoom */
    let startX = null;
    let startY = 0;
    dialog.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1 || (window.visualViewport && window.visualViewport.scale > 1.05)) { startX = null; return; }
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    dialog.addEventListener('touchend', (e) => {
      if (startX === null) return;
      const dx = e.changedTouches[0].clientX - startX;
      const dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) step(dx < 0 ? 1 : -1);
      startX = null;
    }, { passive: true });

    document.body.appendChild(dialog);
  }

  function render() {
    const photo = photos[current];
    img.src = photo.src;
    img.alt = photo.alt;
    if (count) count.textContent = current + 1 + ' / ' + photos.length;
  }
  function step(dir) {
    if (photos.length < 2) return;
    current = (current + dir + photos.length) % photos.length;
    render();
  }
  function openViewer(index) {
    if (!dialog) build();
    opener = document.activeElement;
    current = index;
    render();
    frame && frame.classList.remove('is-magnified');
    document.documentElement.classList.add('has-zoom');
    dialog.showModal();
  }
}

function initTabs(root) {
  const tablist = root.querySelector('[data-tablist]');
  if (!tablist) return;
  const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
  const panels = tabs.map((tab) => document.getElementById(tab.getAttribute('aria-controls')));

  function select(index, focus) {
    tabs.forEach((tab, i) => {
      const active = i === index;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
      if (panels[i]) panels[i].hidden = !active;
    });
    if (focus) tabs[index].focus();
  }

  tabs.forEach((tab, i) => {
    tab.addEventListener('click', () => select(i, false));
    tab.addEventListener('keydown', (event) => {
      let next = null;
      if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
      if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next !== null) {
        event.preventDefault();
        select(next, true);
      }
    });
  });

  tablist.hidden = false;
  root.classList.add('is-tabbed');
  select(0, false);
}

/* Calculator button: a light sheen and arrow nudge the first time it comes into view */
function initCalcCta(cta) {
  if (!('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver((entries) => {
    if (!entries[0].isIntersecting) return;
    cta.classList.add('is-nudged');
    io.disconnect();
  }, { threshold: 0.9 });
  io.observe(cta);
}

document.querySelectorAll('[data-gallery]').forEach(initGallery);
document.querySelectorAll('[data-calc-cta]').forEach(initCalcCta);
document.querySelectorAll('[data-tabs]').forEach(initTabs);
